import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import styles from '../../Css/FabricCropModal.module.css'
import Cropper from './PrespectiveCrop/Cropper'

const FreeHandCropping = (props) => {

    const [img, setImg] = useState(props.fabricFile)
    const [cropState, setCropState] = useState()
    const cropperRef = useRef()
    const onDragStop = useCallback((s) => setCropState(s), [])
    const onChange = useCallback((s) => setCropState(s), [])
    const previewCanvasRef1 = useRef(null);
    const [degree, setDeg] = useState(0)
    const [isCroppingDone, setIsCroppingDone] = useState(false)
    let fileInput;

    const handleRotation = async (e) => {
        try {
            setDeg(degree + e)
            let deg = degree + e
            var canvasImg = new Image;

            canvasImg.src = props.fabric;
            const canvas = previewCanvasRef1.current;

            var context = canvas.getContext("2d");

            canvas.width = canvasImg.width;
            canvas.height = canvasImg.height;

            var rad = deg * Math.PI / 180
            var _rad = (deg % 90) * Math.PI / 180;
            var i = {
                w: canvas.width * Math.cos(_rad) + canvas.height * Math.sin(_rad),
                h: canvas.width * Math.sin(_rad) + canvas.height * Math.cos(_rad)
            };

            if (((deg / 90) | 0) % 2) {
                var t = i.w;
                i.w = i.h;
                i.h = t;
            }
            i.x = (i.w - canvas.width) / 2;
            i.y = (i.h - canvas.height) / 2;

            context.drawImage(canvasImg, 0, 0, canvasImg.width, canvasImg.height);
            canvas.height = i.h;
            canvas.width = i.w;
            context.save()
            context.translate(i.w / 2, i.h / 2);
            context.rotate(rad);
            context.drawImage(canvasImg, 0, 0, canvasImg.width, canvasImg.height, -i.w / 2 + i.x, -i.h / 2 + i.y, canvasImg.width, canvasImg.height);
            context.restore();
            try {
                canvas.toBlob(async (blob) => {
                    if (blob) {
                        var file = new File([blob], "name")
                        // console.log(file)
                        setImg(file)
                    }
                }, "image/png");
            }
            catch (exception) {
                throw exception
            }
        }
        catch (exception) {
            //   console.log(exception)
        }
    };

    const doSomething = async () => {
        try {

            const res = await cropperRef.current.done({ preview: true })

            var file = new File([res], "name")
            props.handleCroppedFabric(file)
            setImg(file)
            setIsCroppingDone(true)

        } catch (e) {
            // console.log('error', e)
        }
    }

    const finishROtationAndCroping = () => {
        props.handleCroppedFabric(img)
        props.setShowFabricCropModal(false)

    }

    const handleUpload = (e) => {
        let image = e.target.files[0]
        setImg(image)
        props.handleCroppedFabric(image)
        setIsCroppingDone(false)
    }

    return (
        <React.Fragment>
            <Modal
                show={props.showFabricCropModal}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                size='xl'
                centered
            >
                <Modal.Header className={[styles['header-title'], 'row'].join(' ')}>
                    <div className={[styles['header-heading'], 'col-md-6 col-6'].join(' ')}>
                        <h4>Crop & Rotate</h4>
                    </div>
                    <div className={[styles['header-heading'], 'col-3'].join(' ')}>
                    </div>
                    <div onClick={() => fileInput.click()} className={[styles['header-reupload'], 'col-2 text-right'].join(' ')}>
                        <input
                            type="file"
                            className="d-none"
                            onChange={(e) => handleUpload(e)}
                            ref={(file) => (fileInput = file)}
                        />
                        <h5><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/upload.png" /> Re-Upload</h5>
                    </div>
                    <div className="col-1 text-right" style={{cursor:"pointer"}}>
                        <img onClick={() => props.setShowFabricCropModal(false)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/close_big.png" />
                    </div>
                </Modal.Header>
                <Modal.Body className={[styles['crop-body'], 'row'].join(' ')}>
                    <div className={[styles['crop-image'], 'col-md-12'].join(' ')}>
                        {!isCroppingDone ?
                            <Cropper
                                ref={cropperRef}
                                image={img}
                                onChange={onChange}
                                onDragStop={onDragStop}
                                maxWidth={600}
                                maxHeight={600}

                            />
                            :
                            <img src={URL.createObjectURL(img)} style={{
                                maxWidth: '600px',
                                maxHeight: '600px'
                            }} />
                        }
                    </div>
                    <div className={[styles['btns-area'], 'col-md-12'].join(' ')}>
                        {!isCroppingDone ?
                            <button onClick={() => doSomething()} className={[styles['crop']]}>Crop</button>
                            :
                            null
                        }
                        <button onClick={() => handleRotation(90)} className={[styles['crop']]}>Rotate<i class="fa fa-rotate-right " ></i></button>
                        <button onClick={() => finishROtationAndCroping()} className={[styles['continue']]}>Continue</button>
                    </div>
                    <canvas
                        ref={previewCanvasRef1}
                        style={{
                            display: "none"
                        }}
                    />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}
export default FreeHandCropping;